import type { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import Icon from './pdf.svg'

type Props = {
  size?: 'small' | 'regular'
} & ComponentPropsWithoutRef<'svg'>

export const PDFIcon = ({ size = 'regular', ...props }: Props) => {
  return <StyledIcon {...props} data-size={size} />
}

const StyledIcon = styled(Icon)`
  transition: fill 0.3s ease;
  fill: ${theme.colors.trialBlue};

  &[data-size='regular'] {
    width: 18px;
    height: 24px;
  }

  &[data-size='small'] {
    width: 12px;
    height: 28px;
  }
`
